/**
 *  11/11/2020 v 1.0 - JuanMa
 **/


export const obtenerSedeCodigo= () => {

    let search= window.location.search;
    let pos = search.indexOf("s=");
    let posSiguienteAmpersand= search.indexOf("&");
    let sedeCodigo= 1;
    if (pos >= 0) {
        sedeCodigo = search.substring(pos + 2);
        if (posSiguienteAmpersand > 0)
            sedeCodigo = search.substring(pos + 2, posSiguienteAmpersand);
    }
    return sedeCodigo;
}
